<template>
  <div class="business">
    <Bg ref="bgs"></Bg>
    <div class="title">
      <div class="title-logo"></div>
      <div class="title-right">
        <div class="title-user">
          <user-info v-if="!ifLogin"></user-info>
          <login-user v-if="ifLogin" class="tc" :setLo="true" :gotoNews="true" :hasDot="isdot"></login-user>
        </div>
      </div>
    </div>
    <div class="info-wrap" ref="bodyH">
      <div class="info-top">
        <div class="info-status" v-if="ifLogin">
          <div class="info-status-list">
            <div class="info-all chartNum">{{ siteSuccess+siteWarning+siteError }}</div>
            <div class="chartStatusBox" ref="chartAll"></div>
            <div @click="statusTab(0)" class="activeTab" style="color:#21a2f5;">全部</div>
          </div>
          <div class="info-status-list">
            <div class="info-error chartNum">{{siteError}}</div>
            <div class="chartStatusBox" ref="chartError"></div>
            <div @click="statusTab(1)" class="activeTab">严重</div>
          </div>
          <div class="info-status-list">
            <div class="info-warning chartNum">{{siteWarning}}</div>
            <div class="chartStatusBox" ref="chartWarning"></div>
            <div @click="statusTab(2)" class="activeTab">预警</div>
          </div>
          <div class="info-status-list">
            <div class="info-success chartNum">{{siteSuccess}}</div>
            <div class="chartStatusBox" ref="chartSuccess"></div>
            <div @click="statusTab(3)" class="activeTab">正常</div>
          </div>
        </div>
      </div>
      <div class="info-search" v-if="ifLogin">
        <el-input
          v-model="searchValue"
          @keyup.enter.native="searchSite"
          clearable
          @clear="clearSearch"
          size="mini"
          placeholder="网站搜索"
          class="inputA"
        ></el-input>
      </div>
      <div class="switchSite" v-show="ifLogin">
        <span class="nxsite insite" @click="nxsite()">逆行监控网站</span>
        <span class="mesite" @click="mesite()">我的监控网站</span>
      </div>
      <div class="editPro" v-show="actPro" :class="{editData:actPro}">
        <div class="editBox">
          <div class="editContent webM">
            <el-dialog :visible.sync="actPro" :before-close="resetAddSite" title="新增监控网站">
              <el-form ref="addSite" :model="addSite" :rules="addRules" label-position="left">
                <el-form-item label="网站名称" prop="name" style="margin-bottom:10px">
                  <el-input v-model="addSite.name" />
                </el-form-item>
                <el-form-item label="网站地址" prop="address" style="margin-bottom:10px">
                  <el-input v-model="addSite.address" />
                </el-form-item>
                <el-form-item>
                  <div class="editBtn">
                    <span><el-button  type="primary" @click="addMesite()">新增</el-button></span>
                    <span><el-button @click="resetAddSite">取消</el-button></span>
                    </div>
                </el-form-item>
              </el-form>
            </el-dialog>
            
          </div>
        </div>
      </div>
      <div class="web-table" v-if="ifLogin">
        <div class="tableBox" v-for="(item,index) in resInfo" :key="index">
          <div
            class="tableItem"
            :class="item.status === '严重'?'yanzhong':item.status==='yujing'?'warning':'zhengchang'" >
            <div class="tableName">{{ item.name }}</div>
            <div class="line"></div>
            <div class="siteBox">
              <div class="siteOne">
                <div class="address">
                  <span>网站地址：</span>
                  {{ item.address }}
                </div>
                <div class="speed">
                  <span>响应速度：</span>
                  {{ item.resTime }}
                  <span class="second">秒</span>
                </div>
                <div class="pv" v-if="!adds">
                  <span>PV：{{ item.pv?item.pv:'---' }}</span>
                  <span>UV：{{ item.uv?item.uv:'---' }}</span>
                </div>
                <div class="cpu" v-if="!adds">
                  <span class="lineLeft">CPU使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.cpuUsage}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.cpuUsage }}</span>
                </div>
                <div class="cpu" v-if="!adds">
                  <span class="lineLeft">内存使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.memUsage}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.memUsage }}</span>
                </div>
              </div>
              <div class="siteTwo" v-if="!adds">
                <div class="address">
                  <span>网站地址：</span>
                  {{ item.address2 }}
                </div>
                <div class="speed">
                  <span>响应速度：</span>
                  {{ item.resTime2 }}
                  <span class="second">秒</span>
                </div>
                <div class="pv">
                  <span>PV：{{ item.pv2?item.pv2:'---' }}</span>
                  <span>UV：{{ item.uv2?item.uv2:'---' }}</span>
                </div>
                <div class="cpu">
                  <span class="lineLeft">CPU使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.cpuUsage2}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.cpuUsage2 }}</span>
                </div>
                <div class="cpu">
                  <span class="lineLeft">内存使用率：</span>
                  <div class="lineBox">
                    <div class="lineItem" :style="{width:item.memUsage2}">
                      <div class="boxItem"></div>
                    </div>
                    <div class="wLine">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <span class="lineText">{{ item.memUsage2 }}</span>
                </div>
              </div>
            </div>
            <div class="tableBtn" v-if="!adds">
              <div class="siteBtnTwo" @click="siteTwoShow(index,$event)" v-if="item.address2">站点二</div>
              <div class="siteBtnOne" @click="siteOneShow(index,$event)" v-if="item.address">站点一</div>
            </div>
            <div class="tableLike">
              <img :src="getLike(item)" @click="likes(index, $event)" alt />
            </div>
          </div>
        </div>
        <div class="tableBox"  v-show="ifLogin && adds"  v-if="Math.ceil(webShow.length / 12) == pageNum && adds || webShow.length == 0">
          <div class="tableItem zhengchang">
            <div class="tableName">点击添加你想关注的网站</div>
            <div class="line"></div>
            <dir class="addImg" @click="addSiteShow()">
              <img src="../../assets/addSite.png" alt="" srcset="">
            </dir>
          </div>
        </div>
      </div>
      <div class="loading" v-if="loadingShow === true">
        <div class="loadingImg"></div>
      </div>
      <div class="info-page" v-show="value" v-if="ifLogin">
        <el-pagination
          background
          layout="prev,pager,next"
          :page-size="pageCount"
          :total="webShow.length"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
        ></el-pagination>
      </div>
      <div class="noData" v-show="dataLength && !adds">
        <img :src="noData" alt />
        <div class="noText">无数据</div>
      </div>
    </div>
    <MobileNav />
  </div>
</template>

<script>
import { setUserInfo } from '@/js/utils'
import MobileNav from "../MobileNav";
import UserInfo from "../user";
import Bg from "../bg.vue";
var echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/pie"); // 饼图
const likeImg = require("@/assets/like.png");
const unlikeImg = require("@/assets/unlike.png");

import loginUser from "../user2";

export default {
  components: {
    MobileNav,
    UserInfo,
    Bg,
    loginUser
  },
  data() {
    return {
      description: "监控客户网站响应速度",
      showTime: "",
      showTime1: "",
      webRes: [],
      webTemp: [],
      webShow: [],
      isdot: false,
      showStatus: "全部",
      showColor: {
        全部: "#409eff",
        正常: "#67C23A",
        预警: "#E6A23C",
        严重: "#F56C6C"
      },
      resInfo: [],
      pageTotal: null,
      pageNum: 1,
      pageCount: 8,
      siteSuccess: 0,
      siteWarning: 0,
      siteError: 0,
      searchValue: "",
      searchMode: false,
      statusTabs: ["全部", "严重", "预警", "正常"],
      value: false,
      noData: require("../../assets/noData.png"),
      dataLength: false,
      loading: false,
      loadingShow: true,
      adds:false,
      actPro:false,
      addSite:{
        name:null,
        address:null,
      },
      addRules: {
        name: { required: true },
        address: { required: true },
      },
    };
  },
  mounted() {
    var me = this;
    me.getShowTime();
    setInterval(me.getShowTime, 1000);

    this.loadingShow = true;
    if (localStorage.getItem("Lo") == 3 || me.ifLogin) {
      me.getSite();
      me.$refs.bgs.clearAll();
      me.loadingShow = false;
    } else {
      me.value = false;
      localStorage.setItem("Lo", 2);
      me.$refs.bgs.all();
    }
    if (me.$store.state.badge > 0) {
      me.isdot = true
    } else {
      me.isdot = false
    }
    setTimeout(function() {
      me.loadingShow = false;
    }, 500);
  },
  sockets: {
    receiveSite: function(data) {
      var me = this;
      me.webTemp = data;
      me.webRes = JSON.parse(JSON.stringify(me.webTemp));
      for (let i = 0; i < me.webRes.length; i++) {
        if (me.webRes[i].status === "严重" || me.webRes[i].status2 === "严重") {
          me.webRes[i].status = "严重";
          me.webRes[i].status2 = "严重";
        } else if (
          me.webRes[i].status === "预警" ||
          me.webRes[i].status2 === "预警"
        ) {
          me.webRes[i].status = "预警";
          me.webRes[i].status2 = "预警";
        }
      }
      setTimeout(function() {
        me.loadingShow = false;
      }, 500);
      me.pageInit();
      me.value = true;
      if (this.webShow.length<9) {
        this.value = false
      }else{
        this.value = true;
      }
    },
    getUserInfo: function(data) {
      var that = this;
      setUserInfo.call(this, data)
      setTimeout(function(){
        if (that.$store.state.badge > 0) {
          that.isdot = true
        } else {
          that.isdot = false
        }
      }, 1000)
      that.getSite();
      that.loadingShow = false;
    },
    getUsersite: function(data) {
      var me = this;
      console.log('datae3333', data)
      me.webTemp = data;
      me.webRes = JSON.parse(JSON.stringify(me.webTemp));
      for (let i = 0; i < me.webRes.length; i++) {
        if (me.webRes[i].status === '严重' || me.webRes[i].status2 === '严重') {
          me.webRes[i].status = '严重'
          me.webRes[i].status2 = '严重'
        }else if(me.webRes[i].status === '预警' || me.webRes[i].status2 === '预警'){
          me.webRes[i].status = '预警'
          me.webRes[i].status2 = '预警'
        }
      }
      me.pageInit();
      me.value = true;
      if (this.webShow.length<9) {
        this.value = false
      }else{
        this.value = true;
      }
    },
    oneSiteRes: function(data){
      console.log('data', data)
      this.getUsersite()
    },
    addMeSite: function(data){
      var me = this;
      var me = this;
      me.resetAddSite()
      if (data.ok == 0) {
        me.$message.error(data.data);
        return;
      }
      me.$store.state.userSite = data.data;
      me.$message({
          message: '站点已添加！',
          type: 'success'
        });
      me.$socket.emit('oneSiteRes', data.address)
      me.getUsersite()
    },
  },
  methods: {
    getLike(item) {
      if (!this.adds) {
        if (this.$store.state.likeweb) {
          return this.$store.state.likeweb.indexOf(item.id) == -1
            ? unlikeImg
            : likeImg;
        } else if (!this.$store.state.likeweb) {
          return unlikeImg;
        }
      }else {
        if (this.$store.state.userSite) {
          return this.$store.state.userSite.indexOf(item.id) == -1
            ? unlikeImg
            : likeImg;
        } else if (!this.$store.state.userSite) {
          return unlikeImg;
        }
      }
      
    },
    likes(index, evt) {
      if (!this.ifLogin) {
        this.$router.push("/");
      } else {
        if (!this.adds) {
          if(this.$store.state.likeweb.indexOf(this.resInfo[index].id) == -1){
            this.$store.commit('addlikeWeb',this.resInfo[index].id)
            this.$socket.emit('changeLike',{
              likeweb:this.$store.state.likeweb,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple,
            })
          }
          else{
            this.$store.commit('deletelikeWeb',this.resInfo[index].id)
            this.$socket.emit('changeLike',{
              likeweb:this.$store.state.likeweb,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple,
            })
          }
        } else {
          if(this.$store.state.userSite.indexOf(this.resInfo[index].id) == -1){
            this.$store.commit('adduserSite',this.resInfo[index].id)
            this.$socket.emit('changeUserLike',{
              userSite:this.$store.state.userSite,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple,
            })
          }
          else{
            this.$store.commit('deleteuserSite',this.resInfo[index].id)
            this.$socket.emit('changeUserLike',{
              userSite:this.$store.state.userSite,
              name:this.$store.state.userName,
              unionid: this.$store.state.wxAppData,
              userApple: this.$store.state.userApple,
            })
          }
        }
      }
    },
    getShowTime() {
      var me = this;
      var nowTime = new Date();
      var year = nowTime.getFullYear();
      var month = nowTime.getMonth() + 1;
      var date = nowTime.getDate();
      var hour = nowTime.toLocaleTimeString();
      me.showTime = year + "-" + month + "-" + date;
      me.showTime1 = hour;
    },
    getSite() {
      var me = this;
      me.$socket.emit("getSite");
    },
    getUsersite() {
      var me = this;
      me.$socket.emit('getUsersite',{
        likeweb:me.$store.state.userSite
      })
    },
    pageInit() {
      var me = this;
      me.webShow = [];
      if (me.showStatus === "全部") {
        me.webShow = JSON.parse(JSON.stringify(me.webRes));
      } else if (me.showStatus === "正常") {
        for (var i in me.webRes) {
          if (
            me.webRes[i].status === "正常" ||
            me.webRes[i].status2 === "正常"
          ) {
            me.webShow.push(me.webRes[i]);
          }
        }
      } else if (me.showStatus === "预警") {
        for (var i in me.webRes) {
          if (
            me.webRes[i].status === "预警" ||
            me.webRes[i].status2 === "预警"
          ) {
            me.webShow.push(me.webRes[i]);
          }
        }
      } else if (me.showStatus === "严重") {
        for (var i in me.webRes) {
          if (
            me.webRes[i].status === "严重" ||
            me.webRes[i].status2 === "严重"
          ) {
            me.webShow.push(me.webRes[i]);
          }
        }
      }
      me.resInfo = me.webShow.slice(
        (me.pageNum - 1) * me.pageCount,
        me.pageNum * me.pageCount
      );
      me.pageTotal = Math.ceil(me.webShow.length / me.pageCount);
      me.siteSuccess = me.siteWarning = me.siteError = 0;
      for (var i in me.webRes) {
        me.webRes[i].status === "严重"
          ? (me.siteError += 1)
          : me.webRes[i].status === "预警"
          ? (me.siteWarning += 1)
          : (me.siteSuccess += 1);
      }
    },

    pageAutoChange() {
      var me = this;
      me.pageNum === me.pageTotal ? (me.pageNum = 1) : (me.pageNum += 1);
      me.pageInit();
    },
    handleCurrentChange(val) {
      var me = this;
      me.pageNum = val;
      me.pageInit();
    },
    // chooseStatus(command) {
    //   var me = this;
    //   me.pageNum = 1;
    //   me.showStatus = command;
    //   me.pageInit();
    // },
    searchSite(e) {
      var me = this;
      me.webRes = [];
      for (var item of me.webTemp) {
        if (
          item.name.indexOf(me.searchValue) !== -1 ||
          item.address.indexOf(me.searchValue) !== -1
        ) {
          me.webRes.push(item);
        } else if (
          item.address2 &&
          item.address2.indexOf(me.searchValue) !== -1
        ) {
          me.webRes.push(item);
        }
      }
      me.pageNum = 1;
      me.pageInit();
    },
    clearSearch(e) {
      var me = this;
      me.webRes = JSON.parse(JSON.stringify(me.webTemp));
      me.pageInit();
    },
    chartError(dom, num, color, nums) {
      var me = this;
      var chartStatus = echarts.init(dom);
      if (num === nums) {
        num = 0;
      }
      var data = [
        {
          value: num,
          name: "01",
          itemStyle: {
            normal: {
              color: color
            }
          }
        },
        {
          name: "02",
          value: nums - num
        }
      ];
      var option = {
        color: "#303b4a",
        legend: {
          show: false
        },
        series: [
          {
            name: "Line 1",
            type: "pie",
            clockWise: true,
            radius: ["65%", "90%"],
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            hoverAnimation: false,
            data: data
          }
        ]
      };
      chartStatus.setOption(option);
    },
    chartAlls(dom, num1, num2, num3) {
      var me = this;
      var chartStatus = echarts.init(dom);
      var data = [
        {
          value: num1,
          name: "01",
          itemStyle: {
            normal: {
              color: "#67C23A"
            }
          }
        },
        {
          name: "02",
          value: num2,
          itemStyle: {
            normal: {
              color: "#E6A23C"
            }
          }
        },
        {
          name: "03",
          value: num3,
          itemStyle: {
            normal: {
              color: "#F56C6C"
            }
          }
        }
      ];
      var option = {
        color: "#303b4a",
        legend: {
          show: false
        },
        series: [
          {
            name: "Line 1",
            type: "pie",
            clockWise: true,
            radius: ["65%", "90%"],
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            hoverAnimation: false,
            data: data
          }
        ]
      };
      chartStatus.setOption(option);
    },
    siteOneShow(index, evt) {
      var me = this;
      clearInterval(me.siteChange);
      if (evt.currentTarget.previousElementSibling) {
        let siteOne = document.getElementsByClassName("siteOne")[index];
        let siteTwo = document.getElementsByClassName("siteTwo")[index];
        siteOne.style.top = "0";
        siteOne.style.opacity = "1";
        siteTwo.style.top = "100%";
        siteTwo.style.opacity = "0";
        evt.toElement.style.backgroundColor = "#222a36";
        evt.currentTarget.previousElementSibling.style.backgroundColor =
          "transparent";
      }
      me.siteChange = setInterval(me.pageAutoChange, 10 * 1000);
    },
    siteTwoShow(index, evt) {
      var me = this;
      clearInterval(me.siteChange);
      if (evt.currentTarget.nextElementSibling) {
        let siteOne = document.getElementsByClassName("siteOne")[index];
        let siteTwo = document.getElementsByClassName("siteTwo")[index];
        siteOne.style.top = "-80%";
        siteOne.style.opacity = "0";
        siteTwo.style.top = "0";
        siteTwo.style.opacity = "1";
        evt.currentTarget.nextElementSibling.style.backgroundColor =
          "transparent";
        evt.toElement.style.backgroundColor = "#222a36";
      }

      me.siteChange = setInterval(me.pageAutoChange, 10 * 1000);
    },
    statusTab(index) {
      function removeByValue(arr, val) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == val) {
            arr.splice(i, 1);
            break;
          }
        }
      }
      let box = [0, 1, 2, 3];
      let text = document.getElementsByClassName("activeTab")[index].innerText;
      document.getElementsByClassName("activeTab")[index].style.color =
        "#21a2f5";
      this.showStatus = text;
      this.pageNum = 1;
      this.pageInit();
      removeByValue(box, index);
      for (let i = 0; i < box.length; i++) {
        document.getElementsByClassName("activeTab")[box[i]].style.color =
          "#ffffff";
      }
      if (this.webShow.length < 9) {
        this.value = false;
      } else {
        this.value = true;
      }
      this.dataLength = false;
      if (this.webShow.length === 0) {
        this.dataLength = true;
      }
    },
    nxsite: function() {
      clearInterval(this.siteChange)
      document.getElementsByClassName("nxsite")[0].style.color = '#21a2f5';
      document.getElementsByClassName("mesite")[0].style.color = '#ffffff';
      this.getSite();
      this.pageNum = 1;
      this.adds = false;
      this.siteChange = setInterval(this.pageAutoChange, 10 * 1000);
    },
    mesite: function() {
      clearInterval(this.siteChange)
      document.getElementsByClassName("mesite")[0].style.color = '#21a2f5';
      document.getElementsByClassName("nxsite")[0].style.color = '#ffffff';
      this.getUsersite();
      this.pageNum = 1;
      this.adds = true;
      this.siteChange = setInterval(this.pageAutoChange, 10 * 1000);
    },
    addSiteShow(){
      this.actPro = !this.actPro;
    },
    resetAddSite() {
      var me = this
      me.addSite = {
        name:null,
        address:null,
      }
      me.actPro = false
    },
    addMesite() {
      var me = this
      var me = this
      if (me.addSite.name && me.addSite.address) {
        if (me.IsURL(me.addSite.address)) {
          me.$socket.emit('addMeSite', {
            userName: me.$store.state.userName,
            unionid: me.$store.state.wxAppData,
            userApple: me.$store.state.userApple,
            name: me.addSite.name,
            address: me.addSite.address,
            userSite: me.$store.state.userSite
          })
        }else{
          me.$message.error({message:'请输入正确的网站地址',center: true});
          me.resetAddSite()
        }
      }else{
        me.$message({
          message: '网站名称或网站地址不能为空',
          type: 'warning',
          center: true
        });
        me.resetAddSite()
      }
    },
    IsURL(str_url){
      var strRegex = "^((https|http|ftp|rtsp|mms)?://)"
      + "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@ 
        + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184 
        + "|" // 允许IP和DOMAIN（域名）
        + "([0-9a-z_!~*'()-]+\.)*" // 域名- www. 
        + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名 
        + "[a-z]{2,6})" // first level domain- .com or .museum 
        + "(:[0-9]{1,4})?" // 端口- :80 
        + "((/?)|" // a slash isn't required if there is no file name 
        + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$"; 
        var re=new RegExp(strRegex); 
      //re.test()
        if (re.test(str_url)){
        return (true); 
        }else{ 
        return (false); 
        }
    },
  },
  watch: {
    siteError: function() {
      var me = this;
      me.$nextTick(function() {
        //初始化echarts
        if (me.siteWarning === "为空") {
          me.siteWarning = 0;
        }
        setTimeout(function() {
          if (me.$refs.chartError) {
            me.chartError(
              me.$refs.chartError,
              me.siteError,
              "#F56C6C",
              me.siteError + me.siteWarning + me.siteSuccess
            );
          }
        }, 500);
      });
    },
    siteWarning: function() {
      var me = this;
      me.$nextTick(function() {
        //初始化echarts
        if (me.siteWarning === "为空") {
          me.siteWarning = 0;
        }
        setTimeout(function() {
          if (me.$refs.chartWarning) {
            me.chartError(
              me.$refs.chartWarning,
              me.siteWarning,
              "#E6A23C",
              me.siteError + me.siteWarning + me.siteSuccess
            );
          }
        }, 500);
      });
    },
    siteSuccess: function() {
      var me = this;
      me.$nextTick(function() {
        //初始化echarts
        if (me.siteWarning === "为空") {
          me.siteWarning = 0;
        }
        setTimeout(function() {
          if (me.$refs.chartSuccess) {
            me.chartError(
              me.$refs.chartSuccess,
              me.siteSuccess,
              "#67C23A",
              me.siteError + me.siteWarning + me.siteSuccess
            );
            me.chartAlls(
              me.$refs.chartAll,
              me.siteSuccess,
              me.siteWarning,
              me.siteError
            );
          }
        }, 500);
      });
    }
  },
  computed: {
    dropdownColor() {
      var me = this;
      if (me.showStatus === "全部") {
        return "#409eff";
      } else if (me.showStatus === "正常") {
        return "#67c23a";
      } else if (me.showStatus === "预警") {
        return "#e6a23c";
      } else {
        return "#f56c6c";
      }
    },
    ifLogin() {
      return this.$store.state.ifLogin;
    },
    likeweb() {
      return this.$store.state.likeweb;
    },
  }
};
</script>

<style lang="less" scoped>
.business {
  position: relative;
  padding-bottom: 60px;
  margin-top: -8px;
  padding-top: 8px;
  .editPro{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    .editBox{
      z-index: 1000;
      position: absolute;
      width: 50%;
      // height: 370px;
      left: 0;
      right: 0;
      margin: 0 auto;
      margin-top: 60px;
      border-radius: 3%;
      color: #fff;
      font-size: 16px;
      text-align: left;
      overflow: hidden;
      .editTitle{
        text-align: center;
        padding: 5px 0;
      }
      .editContent{
        padding: 15px 20px;
        div{
          padding: 3px 0;
          span{
            display: inline-block;
          }
          span:first-child{
            width: 180px;
          }
        }
        .editBtn{
          padding-top: 20px;
          text-align: right;
          span{
            width: 40px;
            text-align: right;
            button{
              width: 60px;
              height: 30px;
              padding: 8px 10px;
              color: #fff;
              background: #222a36;
              border: 0;
              box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2),0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 3px rgba(0, 0, 0, 0.12) !important;
            }
            button:hover{
              color: #21a2f5;
            }
          }
          span:first-child{
            width: 40px;
            margin-right: 30px;
          }
        }
        .otherTime{
          margin-top: 5px;
        }
        .el-button{
          padding: 3px;
        }
      }
    }
  }
  .el-main {
    padding: 0;
    margin-top: 50px;
  }
  .info-wrap {
    display: flex;
    width: 90%;
    margin: 0 auto;
    top: 0;
    left: 0;
    flex-direction: column;
    align-items: center;
    padding-top: 60px;
    padding-bottom: 25px;
    .loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      background-color: #181e26;
      .loadingImg {
        width: 320px;
        height: 240px;
        background-image: url(../../assets/loading.gif);
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        line-height: 420px;
        color: #21a2f5;
        font-size: 18px;
      }
    }
    #loginByWX {
      font-size: 18px;
      color: #fff;
    }
    .web-table {
      width: 90vw;
      padding-top: 3vh;
      .tableBox {
        width: 100%;
        height: 190px;
        display: inline-block;
        margin: 0 1vw 1vh 0;
      }
      .tableItem {
        width: 100%;
        height: 100%;
        color: #fff;
        background-color: rgba(117, 176, 243, 0.2);
        background-color: #313a46;
        border-radius: 7px;
        padding: 10px 2vw;
        line-height: 14px;
        text-align: left;
        font-size: 14px;
        position: relative;
        overflow: hidden;
        .tableName {
          text-align: left;
          width: 80%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .line {
          width: 80%;
          height: 2px;
          background: rgb(24, 30, 38, 0.4);
          position: absolute;
          top: 32px;
          left: 0;
        }
        .siteBox {
          width: 100%;
          height: 80%;
          overflow: hidden;
          position: relative;
          top: 5%;
          .siteOne {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            transition: all 0.5s;
          }
          .siteTwo {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 100%;
            transition: all 0.5s;
          }
          .address {
            margin-top: 12px;
            font-size: 13px;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .speed {
            margin-top: 6px;
            font-size: 13px;
            .second {
              font-size: 13px;
            }
          }
          .pv {
            margin-top: 6px;
            font-size: 13px;
            span {
              padding-right: 15%;
            }
          }
          .cpu {
            margin-top: 9px;
            font-size: 13px;
            .lineLeft {
              display: inline-block;
              float: left;
            }
            .lineBox {
              width: 35%;
              height: 12px;
              border: 1px solid rgb(146, 146, 148);
              display: inline-block;
              background: #181e26;
              line-height: 10px;
              box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
                0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
              position: relative;
            }
            .lineItem {
              position: absolute;
              width: 1%;
              height: 100%;
              top: 0%;
              z-index: 99;
              overflow: hidden;
            }
            .boxItem {
              width: 100%;
              height: 100%;
              background: linear-gradient(to right, #21a2f5, #fafb0d, #f56c6c);
            }
            .wLine {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0%;
              z-index: 99;
              span {
                width: 1px;
                height: 100%;
                background: rgb(148, 146, 146);
                margin-left: 17%;
                display: inline-block;
              }
            }
            .lineText {
              padding-left: 5px;
            }
          }
        }
        .tableBtn {
          position: absolute;
          bottom: 5%;
          right: 5%;
          width: 100%;
          font-size: 12px;
          z-index: 99;
          div {
            border: 1px solid rgb(148, 146, 146);
            padding: 2px 5px;
            border-radius: 10px;
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
              0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
            float: right;
            display: inline-block;
            margin-left: 8%;
            cursor: pointer;
          }
          .siteBtnOne {
            background: #222a36;
          }
        }
        .tableLike {
          position: absolute;
          top: 4px;
          right: 5%;
          img {
            width: 25px;
            cursor: pointer;
          }
        }
      }
      .zhengchang {
        background: linear-gradient(
          to top right,
          #313a46 20%,
          #444e58 80%
        ); //正常
      }
      .yujing {
        background: linear-gradient(
          to top right,
          rgb(160, 116, 49) 20%,
          rgba(146, 116, 71, 0.6) 80%
        ); //严重
      }
      .yanzhong {
        background: linear-gradient(
          to top right,
          #965252 20%,
          #5c3938 80%
        ); //严重
      }
    }
    .editData{
      z-index: 9999;
      height: 100%;
      transition: all 1s;
    }
    .noData {
      width: 50%;
      margin: 0 auto;
      position: absolute;
      bottom: 8%;
      text-align: center;
      div {
        font-size: 14px;
        color: #ccc;
        margin-top: 2%;
        a {
          padding-left: 3px;
          color: cornflowerblue;
        }
      }
      img {
        width: 100%;
      }
      .noText {
        margin-top: 0%;
      }
    }
  }
  .info-search {
    width: 90vw;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #c7dfea;
    font-size: 14px;
    margin: 5px 0;
    span {
      display: inline-block;
      width: 20vw;
    }
    .el-input {
      display: block;
      padding: 0;
      margin: 0;
      width: 100%;
    }
  }
  .switchSite {
    width: 80vw;
    height: 40px;
    margin-top: 6.5%;
    align-self: center;
    line-height: 40px;
    text-align: left;
    padding: 0 5%;
    font-size: 12px;
    span {
      height: 30px;
      line-height: 25px;
      display: inline-block;
      cursor: pointer;
      border: 1px solid rgb(148, 146, 146);
      padding: 2px 5px;
      margin: 0 5%;
      border-radius: 10px;
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
        0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
      color: #fff;
    }
    .insite{
      color: rgb(33, 162, 245);
    }
  }
  .info-top {
    color: #fff;
    display: flex;
    width: 90vw;
    height: 90px;
    justify-content: space-between;
    margin: 10px 0;
    .info-status {
      display: flex;
      width: 90vw;
      justify-content: space-around;
      font-size: 2vh;
      height: 90px;
      .info-status-list {
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        position: relative;
        .chartStatusBox {
          width: 100%;
          height: 100%;
          // box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
        }
        .chartNum {
          width: 100%;
          font-weight: 600;
          position: absolute;
          top: 21px;
          z-index: 99;
        }
        .info-error {
          color: #f56c6c;
        }
        .info-warning {
          color: #e6a23c;
        }
        .info-success {
          color: #67c23a;
        }
        .activeTab {
          cursor: pointer;
          margin: 5px 10%;
          font-size: 14px;
        }
      }
    }
  }
  .info-table {
    width: 90vw;
    font-size: 18px;
    text-align: center;
    border: 1px solid #fff;
    padding: 3px;
    overflow: hidden;
    img {
      width: 30px;
      margin-left: 80px;
    }
    .info-item {
      display: flex;
      padding: 20px 0;
      &:nth-child(odd) {
        background: rgba(117, 176, 243, 0.3);
      }
      span {
        display: inline;
        margin: 5px 0;
      }
      .info-title {
        display: flex;
        flex: 1;
        flex-direction: column;
        color: #93b5c5;
        text-align: left;
        padding-left: 2vw;
        span {
          width: 35%;
          float: left;
        }
        .status {
          .el-alert {
            width: 60px;
            height: 25px;
            padding: 0;
          }
        }
        .sp {
          width: 65%;
          text-align: center;
          div {
            display: inline;
          }
        }
      }
    }
  }
  .info-page {
    margin-top: 2vh;
    width: 100%;
    margin-bottom: 1vh;
  }
  .ysxy {
    color: #fff;
    font-size: 14px;
    text-decoration: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mobile/mobileWeb.vue